
export const defaultOptions = {
    required: true,
    defaultValue: undefined,
}

/**
 * Reads a integer env var
 *
 * @param {String} name Env key name
 * @param {String} value Env key value (process.env.FOO)
 * @param {Object} [options]
 * @param {Boolean} [options.required]
 * @param {Boolean} [options.defaultValue]
 * @returns {Number}
 */
export const intEnv = (name, value, options = defaultOptions) => {
    
    const opts = { ...defaultOptions, ...options }
    let result = undefined
    
    try {
        result = parseInt(value, 10) || null
    } catch (e) {
        result = undefined
    }
    
    if (opts.required && result === undefined)
        if (opts.defaultValue !== undefined)
            return opts.defaultValue
        else
            throw new Error(`Env var ${name} is required (int)`)
    
    return result
    
}

export const floatEnv = (name, value, options = defaultOptions) => {
    
    const opts = { ...defaultOptions, ...options }
    let result = undefined
    
    try {
        result = parseFloat(value) || null
    } catch (e) {
        result = undefined
    }
    
    if (opts.required && result === undefined)
        if (opts.defaultValue !== undefined)
            return opts.defaultValue
        else
            throw new Error(`Env var ${name} is required (float)`)
    
    return result
    
}

/**
 * Reads a string env var
 *
 * @param {String} name Env key name
 * @param {String} value Env key value (process.env.FOO)
 * @param {Object} [options]
 * @param {Boolean} [options.required]
 * @param {Boolean} [options.defaultValue]
 * @returns {String}
 */
export const stringEnv = (name, value, options = defaultOptions) => {
    
    const opts = { ...defaultOptions, ...options }
    const result = value?.trim()?.length > 0 ? value : undefined
    
    if (opts.required && !result?.length)
        if (opts.defaultValue !== undefined)
            return opts.defaultValue
        else
            throw new Error(`Env var ${name} is required (string)`)
    
    return result
    
}

/**
 * Reads a boolean env var
 *
 * @param {String} name Env key name
 * @param {String} value Env key value (process.env.FOO)
 * @param {Object} [options]
 * @param {Boolean} [options.required]
 * @param {Boolean} [options.defaultValue]
 * @returns {Boolean}
 */
export const boolEnv = (name, value, options = defaultOptions) => {
    
    const opts = { ...defaultOptions, ...options }
    const _value = value?.toLowerCase()
    
    if (opts.required && _value !== 'true' && _value !== 'false')
        if (opts.defaultValue !== undefined)
            return opts.defaultValue
        else
            throw new Error(`Env var ${name} is required (bool)`)
    
    return _value === 'true'
    
}
